import { Box, Typography } from "@mui/material";

interface FileUploadProps {
  label?: string;
  fileName?: string;
  onChange: (
    event: React.ChangeEvent<HTMLInputElement>,
    filekey: string
  ) => void;
  inputId?: string;
  ref?: any;
}

export default function FileUpload({
  label = "Choose File",
  fileName = "No file chosen",
  onChange,
  inputId,
  ref,
}: FileUploadProps) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        textAlign: "center",
      }}
    >
      <label htmlFor={inputId}>
        <Box
          component="span"
          sx={{
            width: "162px",
            height: "45px",
            display: "inline-block",
            padding: "6px 16px",
            backgroundColor: "#D9D9D9",
            color: "#343133",
            borderRadius: "6px",
            border: "1px solid #000000",
            cursor: "pointer",
            fontSize: "20px",
          }}
        >
          {label}
        </Box>
      </label>
      <Typography variant="body1" color="#929191">
        {fileName}
      </Typography>
      <input
        id={inputId}
        accept="image/*,.pdf"
        ref={ref}
        type="file"
        style={{ display: "none" }}
        onChange={(e) => {
          if (inputId) onChange(e, inputId);
        }}
      />
    </Box>
  );
}
